var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNiruthWhitelogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3007,
    height: 1103,
    viewBox: "0 0 3007 1103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1426.53 622.146C1570.37 765.251 1540.94 908.36 1404.04 1051.47C1236.47 955.427 1207.75 822.053 1426.53 622.146Z",
    fill: "#A6CE38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1382.77 1007.67C1457.88 951.576 1482.63 869.616 1441.29 754.88C1457.87 848.115 1440.94 932.997 1382.77 1007.67Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.135636
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1280.86 34.6063L1250.16 73.1812C1127.26 27.5369 1067.09 120.881 1101.07 218.222L1052.22 247.991C973.967 59.5586 1137.07 -63.5715 1280.86 34.6063Z",
    fill: "url(#paint0_linear_375_2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1869.46 358.759C1978.24 408.508 2087.02 405.891 2195.81 350.904C2248.61 329.206 2280.85 377.091 2235.15 407.013C2119.09 477.662 1997.9 492.714 1870.52 440.678L1869.46 358.759Z",
    fill: "url(#paint1_linear_375_2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1283.43 599.929V879.205C1303.79 1043.98 1468.22 1033.72 1491.8 879.205V594.819L1590.65 554.1V910.999C1593.41 987.835 1557.26 1067.65 1460.85 1091.5H1333.85C1253.61 1083.73 1191.83 998.464 1193.33 903.877V556.156L1283.43 599.929Z",
    fill: "url(#paint2_linear_375_2)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1311.31 226.239C1319.58 324.986 1385.21 356.628 1498.37 332.685C1557.25 272.449 1585.63 262.073 1696.4 253.893C1751.41 251.392 1806.43 263.84 1861.44 298.139C1918.24 336.369 1992.46 342.821 2084.11 317.496C2068.97 267.624 2025.31 252.875 1953.13 273.25C1845.52 209.98 1740.04 177.06 1638.77 204.117C1544.12 -12.871 1391.73 -47.0976 1227.33 62.8392C1184.2 91.6871 1144.6 179.008 1150.16 230.56C1091 205.495 1035.74 205.211 989.091 259.424C890.497 379.961 974.998 579.042 1208.94 515.182C1280.51 560.366 1441.87 569.948 1533.24 527.35C1720.08 577.25 1812.29 516.758 1809.05 323.027H1735.65C1762.18 466.151 1614.46 528.66 1547.08 397.691C1426.25 529.065 1314.47 529.065 1211.75 397.691C1008.82 634.81 912.585 185.396 1172.47 295.373C1212.45 1.26014 1510.94 16.7259 1568.04 223.474C1466.52 272.092 1378.82 279.37 1311.31 226.239Z",
    fill: "url(#paint3_linear_375_2)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1096.45V579.724H95.9436L297.393 926.019V579.724H389.004V1096.45H289.991L91.6107 756.785V1096.45H0ZM490.308 1096.45V579.724H589.439V1096.45H490.308ZM683.659 1096.45V579.724H891.838C944.136 579.724 982.197 584.423 1005.89 593.682C1029.71 602.941 1048.63 619.416 1062.86 643.119C1077.11 666.934 1084.29 694.001 1084.29 724.546C1084.29 763.402 1073.57 795.392 1052.04 820.653C1030.51 845.913 998.371 861.79 955.528 868.395C976.837 881.505 994.392 895.948 1008.17 911.7C1022.08 927.452 1040.76 955.48 1064.23 995.657L1123.93 1096.45H1005.78L934.904 983.631C909.499 943.578 892.062 918.317 882.606 907.849C873.267 897.506 863.351 890.291 852.868 886.44C842.278 882.589 825.632 880.67 802.848 880.67H782.79V1096.45H683.659ZM782.79 798.396H855.949C903.348 798.396 932.862 796.227 944.703 792.027C956.449 787.815 965.788 780.475 972.399 770.131C979.116 759.788 982.422 746.803 982.422 731.288C982.422 713.841 977.983 699.883 969.211 689.066C960.428 678.361 948.008 671.619 932.059 668.853C923.972 667.656 899.924 667.058 859.939 667.058H782.79V798.396ZM1857.27 1096.45V667.058H1712.33V579.724H2100.65V667.058H1956.4V1096.45H1857.27ZM2164.79 1096.45V579.724H2263.92V783.242H2456.72V579.724H2555.85V1096.45H2456.72V870.563H2263.92V1096.45H2164.79ZM2655.1 1096.45V579.724H2754.23V1096.45H2655.1Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2899.82,
    cy: 480.336,
    r: 102.294,
    stroke: "white",
    strokeWidth: 8.89516
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2856.57 529.173V412.727H2902.51C2911.31 412.727 2918.81 414.3 2925.03 417.446C2931.28 420.555 2936.04 424.971 2939.3 430.694C2942.6 436.38 2944.25 443.071 2944.25 450.765C2944.25 458.498 2942.58 465.15 2939.24 470.723C2935.91 476.257 2931.07 480.502 2924.74 483.459C2918.45 486.415 2910.83 487.894 2901.89 487.894H2871.13V468.107H2897.91C2902.61 468.107 2906.51 467.463 2909.62 466.174C2912.73 464.885 2915.04 462.952 2916.56 460.374C2918.11 457.797 2918.89 454.594 2918.89 450.765C2918.89 446.899 2918.11 443.639 2916.56 440.986C2915.04 438.332 2912.71 436.323 2909.56 434.959C2906.45 433.556 2902.53 432.855 2897.79 432.855H2881.19V529.173H2856.57ZM2919.46 476.181L2948.4 529.173H2921.22L2892.9 476.181H2919.46Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_375_2",
    x1: -1745.24,
    y1: -6000.22,
    x2: -1517.33,
    y2: -5908.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_375_2",
    x1: 666.054,
    y1: -6483.7,
    x2: 777.172,
    y2: -6530.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_375_2",
    x1: -2805.64,
    y1: -5904.17,
    x2: -2795.74,
    y2: -6441.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_375_2",
    x1: 1054.77,
    y1: -5232.31,
    x2: 1559.94,
    y2: -5378.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNiruthWhitelogo);
export default __webpack_public_path__ + "static/media/niruthWhitelogo.41ecaae8984e28f1cee0401e7a35ba2c.svg";
export { ForwardRef as ReactComponent };